module.exports = __webpack_public_path__ + "static/media/material-info.ae54e2fa.svg";